export const identicalColors = (color1, color2) => {
  return color1?.replace('#', '').toLowerCase() === color2?.replace('#', '').toLowerCase();
};